export const piWorkspaceEn = {
  keepPrices: "Keep reviewed prices",
  newTitle: "New proforma invoice",
  editTitle: "Edit proforma invoice",
  groups: {
    parties: "Parties", partiesHint: "Choose the buyer first — the notify party and consignee follow it and can be changed.",
    terms: "Terms", termsHint: "Date, customer references, delivery, currency and payment.",
    lines: "Goods", linesHint: "Add products from the catalogue or type a line. Rarely used columns stay hidden until needed.",
    notes: "Remarks",
  },
  partyCustomer: "Customer",
  partyContact: "Contact",
  filled: "{{count}} filled",
  sideShow: "Show extra columns",
  sideHide: "Hide extra columns",
  sideColumns: "Customer style no., EXW price, under-MOQ price, DTD price",
  sideLocked: "A line uses the extra columns, so they stay visible.",
  reloadPrices: "Reload customer prices",
  savedContact: "Saved contact snapshot",
  reviewPrices: "Customer changed. Review each billed price before saving.",
  currencyReset:
    "Currency changed. Enter or reload prices in the new currency.",
  priceHint:
    "Customer pricing applies when adding products. Prices in another currency stay blank; enter a reviewed price in {{currency}}. EXW/DTD are reference prices.",
  preview: "Saved PI · Print preview",
  voidPayment: "Void receipt",
  voidHint:
    "Keep the original receipt in history and remove it from the paid balance. Enter the reason.",
  reason: "Reason",
  voided: "Voided",
  credit: "Customer credit",
  overpayment: "This exceeds the balance and creates customer credit.",
  packingConfirm:
    "Create a packing document from PI {{number}} ({{count}} lines)? Review quantities in the packing editor before shipment. If an active packing list exists, it will open for review.",
  exportPage: "Export this page",
  exportFiltered: "Export all matches",
  from: "PI date from",
  to: "PI date to",
  sort: "Sort",
  newest: "Newest date first",
  oldest: "Oldest date first",
  columns: "Columns",
  financeView: "Financial overview",
  fullView: "All document columns",
  pi_currency_locked: "Currency is locked after receipt history exists.",
  pi_dependencies_locked:
    "Related invoice, purchase order or packing documents exist. Archive them before changing commercial fields or archiving this PI.",
  pi_payment_retry_conflict:
    "This receipt request was already recorded with different details. Reload and reconcile before recording another receipt.",
  pi_void_reason_required: "Enter a reason for voiding the receipt.",
  pi_party_unavailable:
    "The selected customer or payment company is unavailable.",
};
export const piWorkspaceVi = {
  keepPrices: "Giữ giá đã kiểm tra",
  newTitle: "Hóa đơn chiếu lệ mới",
  editTitle: "Sửa hóa đơn chiếu lệ",
  groups: {
    parties: "Các bên", partiesHint: "Chọn bên mua trước — bên nhận thông báo và bên nhận hàng tự lấy theo, đổi được.",
    terms: "Điều khoản", termsHint: "Ngày, tham chiếu của khách, giao hàng, tiền tệ và thanh toán.",
    lines: "Hàng hoá", linesHint: "Thêm sản phẩm từ danh mục hoặc gõ dòng. Cột ít dùng ẩn cho tới khi cần.",
    notes: "Ghi chú",
  },
  partyCustomer: "Khách hàng",
  partyContact: "Người liên hệ",
  filled: "{{count}} ô có dữ liệu",
  sideShow: "Hiện cột phụ",
  sideHide: "Ẩn cột phụ",
  sideColumns: "Mã mẫu khách hàng, giá EXW, giá dưới MOQ, giá DTD",
  sideLocked: "Có dòng đang dùng cột phụ nên cột phụ luôn hiện.",
  reloadPrices: "Lấy lại giá theo khách",
  savedContact: "Liên hệ đã lưu trên PI",
  reviewPrices:
    "Đã đổi khách hàng. Kiểm tra lại đơn giá từng dòng trước khi lưu.",
  currencyReset: "Đã đổi tiền tệ. Nhập hoặc lấy lại giá theo tiền tệ mới.",
  priceHint:
    "Giá riêng của khách được áp dụng khi thêm hàng. Giá khác tiền tệ để trống; nhập giá đã kiểm tra theo {{currency}}. EXW/DTD là giá tham khảo.",
  preview: "PI đã lưu · Xem trước bản in",
  voidPayment: "Hủy khoản thu",
  voidHint:
    "Giữ khoản thu gốc trong lịch sử và loại khỏi số tiền đã thu. Nhập lý do hủy.",
  reason: "Lý do",
  voided: "Đã hủy",
  credit: "Khách trả dư",
  overpayment: "Khoản này vượt công nợ và tạo số tiền khách trả dư.",
  packingConfirm:
    "Tạo phiếu đóng gói từ PI {{number}} ({{count}} dòng)? Kiểm tra số lượng tại trang sửa phiếu trước khi giao hàng. Nếu đã có phiếu đang hoạt động, hệ thống sẽ mở phiếu đó.",
  exportPage: "Xuất trang hiện tại",
  exportFiltered: "Xuất toàn bộ kết quả lọc",
  from: "Ngày PI từ",
  to: "Ngày PI đến",
  sort: "Sắp xếp",
  newest: "Ngày mới nhất trước",
  oldest: "Ngày cũ nhất trước",
  columns: "Cột hiển thị",
  financeView: "Tổng quan công nợ",
  fullView: "Đầy đủ cột chứng từ",
  pi_currency_locked: "Không thể đổi tiền tệ khi đã có lịch sử thu tiền.",
  pi_dependencies_locked:
    "PI đã có hóa đơn, đơn mua hoặc phiếu đóng gói liên quan. Lưu trữ chúng trước khi đổi thông tin thương mại hoặc lưu trữ PI.",
  pi_payment_retry_conflict:
    "Yêu cầu thu tiền này đã được ghi với thông tin khác. Tải lại và đối chiếu trước khi ghi khoản mới.",
  pi_void_reason_required: "Nhập lý do hủy khoản thu.",
  pi_party_unavailable:
    "Khách hàng hoặc công ty thu tiền đã chọn không còn khả dụng.",
};
export const piWorkspaceZh = {
  keepPrices: "保留已复核价格",
  newTitle: "新增形式发票",
  editTitle: "编辑形式发票",
  groups: {
    parties: "各方", partiesHint: "先选买方——通知方与收货方会自动带入，可再修改。",
    terms: "条款", termsHint: "日期、客户参考、交货、币种与付款。",
    lines: "货品", linesHint: "从产品目录加入或直接输入。少用字段在需要前隐藏。",
    notes: "备注",
  },
  partyCustomer: "客户",
  partyContact: "联系人",
  filled: "已填 {{count}} 项",
  sideShow: "显示其他字段",
  sideHide: "隐藏其他字段",
  sideColumns: "客户款号、EXW 价、低于 MOQ 价、DTD 价",
  sideLocked: "有明细使用其他字段，因此会一直显示。",
  reloadPrices: "重新加载客户价格",
  savedContact: "单据已保存联系人",
  reviewPrices: "客户已更改，保存前请复核各项单价。",
  currencyReset: "币种已更改，请重新输入或加载新币种价格。",
  priceHint:
    "新增产品时应用客户价格。不同币种价格留空，请输入已核实的 {{currency}} 价格。EXW/DTD 为参考价格。",
  preview: "已保存 PI · 打印预览",
  voidPayment: "作废收款",
  voidHint: "保留原收款历史并从已付款扣除。请填写原因。",
  reason: "原因",
  voided: "已作废",
  credit: "客户溢付",
  overpayment: "收款超过余额，将产生客户溢付。",
  packingConfirm:
    "从 PI {{number}}（{{count}} 项）创建装箱单？出货前请在编辑页复核数量。若已有有效装箱单，将打开该单据。",
  exportPage: "导出本页",
  exportFiltered: "导出所有筛选结果",
  from: "PI 起始日期",
  to: "PI 结束日期",
  sort: "排序",
  newest: "日期由新到旧",
  oldest: "日期由旧到新",
  columns: "字段",
  financeView: "财务总览",
  fullView: "全部单据字段",
  pi_currency_locked: "已有收款历史，无法更改币种。",
  pi_dependencies_locked:
    "已有相关发票、采购单或装箱单。更改商业信息或归档 PI 前，请先归档相关单据。",
  pi_payment_retry_conflict:
    "此收款请求已有不同数据。请重新加载并核对后再记录。",
  pi_void_reason_required: "请输入作废收款原因。",
  pi_party_unavailable: "所选客户或收款公司不可用。",
};
